import { ContentPage } from '../page-factory/content-page';
import { makarSankrantiPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Makar Sankranti - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        "Experience Makar Sankranti at Magh Mela 2026. Join us for this auspicious bathing date marking the sun's transition into Capricorn.",
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/makar-sankranti',
    },
  ];
};

export default function MakarSankrantiPage() {
  return <ContentPage {...makarSankrantiPage} />;
}
